import allCases from '../../fields/cases/allCases';

export const QUERY_GET_ALL_MPB_CASES = /* GraphQL */ `
	query($limit: Float, $offset: Float, $filter: MietpreisbremseCaseFilter, $notEqual: MietpreisbremseCaseFilter) {
		getAllMietpreisbremseCase(
			limit: $limit
			offset: $offset
			filter: $filter
			notEqual: $notEqual
		) {
			items {
				${allCases}
			}
			total
		}
	}
`;
